import React, { Component } from "react";
import Loading from "../../Loading";
import {
  Card,
  CardHeader,
  CardText,
  Divider,
  Avatar,
  FlatButton,
} from "material-ui";
import Formsy from "formsy-react";
import { FormsyText, FormsySelect } from "formsy-material-ui/lib";

export default class TasklistTasks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tasks: [],
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
      },
    };

    this.taskRow = this.taskRow.bind(this);
    this.childRow = this.childRow.bind(this);
    this.submitUpdateRequest = this.submitUpdateRequest.bind(this);
    this.openUpdateRequestDialog = this.openUpdateRequestDialog.bind(this);
  }

  componentWillMount() {
    let projectId = this.props.projectId;
    let tasklistId = parseInt(this.props.tasklistId);

    let url = `/api/teamwork/projects/${projectId}`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        let tasks;
        json.taskLists.map((tasklist) => {
          if (tasklist.id === tasklistId) {
            tasks = tasklist.children;
          }
        });
        this.setState({ tasks: tasks });
      });
  }

  taskRow(task, i) {
    let percent = parseInt(task.progress);
    let backgroundColor = "#ef9a9a";
    let text = "";
    let expandable = task.children.length > 0 ? true : false;

    if (percent === 100) backgroundColor = "#A5D6A7";
    else if (percent > 49) backgroundColor = "#FFCC80";

    if (!(percent === 0 || percent === 100)) text = task.progress + "%";

    return (
      <Card
        key={i}
        zDepth={2}
        style={{
          backgroundColor: "#7986CB",
          marginTop: "0.35em",
          fontStyle: "bold",
          marginLeft: "3em",
        }}
      >
        <CardHeader
          title={task.title}
          subtitle={task.subtitle}
          actAsExpander={expandable}
          showExpandableButton={expandable}
          avatar={
            <Avatar
              color="#EEEEEE"
              backgroundColor={backgroundColor}
              onClick={this.openUpdateRequestDialog.bind(this, task)}
              style={{ cursor: "pointer" }}
            >
              {text}
            </Avatar>
          }
        ></CardHeader>
        <CardText expandable={true}>
          {task.children.map(this.childRow)}
        </CardText>
      </Card>
    );
  }

  childRow(task, i) {
    return (
      <Card
        key={i}
        zDepth={2}
        style={{
          backgroundColor: "#9FA8DA",
          marginTop: "0.25em",
          marginLeft: "3em",
        }}
      >
        <CardHeader
          title={task.title}
          subtitle={task.subtitle}
          avatar={this.renderAvatar(task.progress)}
        ></CardHeader>
      </Card>
    );
  }

  renderAvatar(progress) {
    let percent = parseInt(progress);
    let backgroundColor = "#ef9a9a";
    let text = "";

    if (percent === 100) {
      backgroundColor = "#A5D6A7";
    } else if (percent > 49) {
      backgroundColor = "#FFCC80";
    }

    if (!(percent === 0 || percent === 100)) {
      text = progress + "%";
    }

    return (
      <Avatar color="#EEEEEE" backgroundColor={backgroundColor}>
        {text}
      </Avatar>
    );
  }

  submitUpdateRequest(data, resource) {
    let url = "/api/teamwork/updateRequest";
    let options = {
      method: "post",
      headers: {
        token: this.props.token.jwt,
        "content-type": "application/json",
      },
      body: JSON.stringify({ data: data, resource: resource }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        let title = "";
        let actions = [
          <FlatButton
            key="ok"
            label="Ok"
            onClick={this.props.closeDialog.bind(this)}
          />,
        ];

        let content = [
          <div
            key="response"
            style={{ width: "75%", marginLeft: "auto", marginBottom: "auto" }}
          >
            {json.status === "OK"
              ? "Request sent successfully"
              : "There was an error"}
          </div>,
        ];

        this.props.openDialog(title, content, actions);
      });
  }

  openUpdateRequestDialog(resource) {
    let { centerStyle } = this.state.styles;
    let title = "";
    let actions = [];

    let content = [
      <Formsy.Form
        key="updateRequest"
        onValidSubmit={(data) => this.submitUpdateRequest(data, resource)}
      >
        <div style={{ width: "75%", marginLeft: "auto", marginBottom: "auto" }}>
          <h4>Request Status Update</h4>
          <h3>{resource.name}</h3>
          <FormsyText
            required
            name="question"
            floatingLabelText="Question to Ask"
            defaultValue="Where are we on this?"
          />
          <br />
          <FlatButton
            key="cancel"
            label="Cancel"
            onClick={this.props.closeDialog.bind(this)}
          />
          <FlatButton key="send" label="Send" type="submit" />
        </div>
      </Formsy.Form>,
    ];
    this.props.openDialog(title, content, actions);
  }

  render() {
    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return <div>{this.state.tasks.map(this.taskRow)}</div>;
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/teamwork/tasklists/TasklistTasks.js